import React from 'react';

import cn from 'clsx';
import { Nav } from 'react-bootstrap';
import { NavLink, useLocation } from 'react-router-dom';

import WorkoutsInviteCounter from '@apps/Workouts/components/WorkoutsInviteCounter';
import PohAva from '@ui-kit/Ava';

import style from './style.module.less';
import { AuthContext } from '../../contexts/AuthContext';

const MainMenu = () => {
  const { pathname } = useLocation();

  const authContext = React.useContext(AuthContext);

  if (authContext.loading) {
    return 'Loading...';
  }

  if (!authContext.user) {
    return (
      <Nav className="d-flex align-items-center">
        <Nav.Link as={NavLink} to="/hiking" id="hiking_link">
          Походы
        </Nav.Link>
        <Nav.Link as={NavLink} to="/workouts" id="workouts_link">
          Тренировки
          <WorkoutsInviteCounter />
        </Nav.Link>
        <Nav.Link as={NavLink} to="/recipes" id="recipes_link">
          Рецепты
        </Nav.Link>
        <Nav.Link as={NavLink} to="/routes" id="routes_link">
          Маршруты
        </Nav.Link>
        {pathname !== '/reg' && (
          <Nav.Link as={NavLink} to="/reg" id="register_link">
            РЕГИСТРАЦИЯ
          </Nav.Link>
        )}
        {pathname !== '/login' && (
          <Nav.Link as={NavLink} to="/login" id="login_link">
            ВОЙТИ
          </Nav.Link>
        )}
      </Nav>
    );
  }

  const { name, photo } = authContext.user;
  return (
    <Nav className={cn('d-flex', 'align-items-center', style.mainMenu)}>
      <Nav.Link as={NavLink} to="/hiking" id="hiking_link">
        Походы
      </Nav.Link>
      <Nav.Link as={NavLink} to="/workouts" id="workouts_link">
        Тренировки
        <WorkoutsInviteCounter />
      </Nav.Link>
      <Nav.Link as={NavLink} to="/recipes" id="recipes_link">
        Рецепты
      </Nav.Link>
      <Nav.Link as={NavLink} to="/routes" id="routes_link">
        Маршруты
      </Nav.Link>
      <Nav.Link as={NavLink} to="/equip" id="equip_link">
        Снаряжение
      </Nav.Link>
      <Nav.Link as={NavLink} to="/profile" id="profile_link" className={style.profileLink}>
        {name}
        <PohAva
          width={50}
          src={photo}
          alt={name}
          className={style.img}
          style={{ backgroundColor: 'grey' }}
        />
      </Nav.Link>
    </Nav>
  );
};

export default MainMenu;
